// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes Hxemd{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}._EoJB{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;min-height:100vh;padding:32px;gap:16px;text-align:center}.NxDDW{animation:Hxemd 600ms ease-out both}.jgCeR{color:#6b3fa0}.CD7BA{margin-bottom:8px}.Jlpi1{color:#444}.XA6vn{margin-top:32px;padding:16px 24px;background:#f3edfb;border-radius:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `_EoJB`,
	"gradualReveal": `NxDDW`,
	"gradualRevealKeyframes": `Hxemd`,
	"checkmark": `jgCeR`,
	"title": `CD7BA`,
	"subtitle": `Jlpi1`,
	"banner": `XA6vn`
};
export default ___CSS_LOADER_EXPORT___;
